import { css } from '@emotion/css';

const contentTable = css`
  position: relative;

  table {
    tr {
      td.loading-td {
        padding: 5px 30px 0;

        .react-loading-skeleton {
          line-height: 3;
        }
      }
    }
  }
`;

const actions = css`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const iconActions = css`
  border: 0;
  background: transparent;

  img {
    width: auto;
  }

  svg {
    background-color: #00b8ad;
    width: 30px;
    height: 30px;
    color: #fff;
    padding: 5px;
    border-radius: 100%;
  }
`;

const CredentialsTableStyles = {
  contentTable,
  actions,
  iconActions,
};

export default CredentialsTableStyles;
